import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CommonSearch from "../../../SharedFiles/CommonSearch/CommonSearch";
import { GetDisassembleBatch, GetDisassembleInput, postDisassembleIT, resetError } from "../../../APIServices/ProductionService/DisassembleService/DisassembleThunk";
import DynamicTable from "../../../SharedFiles/CommonTable/dynamicTable";
import { toast, Toaster } from 'react-hot-toast';
import QrContainer from '../../../SharedFiles/QRCode/qrReader';
import { useTranslation } from 'react-i18next'; 
import { parseFormattedQRText } from "../../../SharedFiles/Helper/utils";


const DisassembleTransfer = ({setOpenManual,openManual,transferModal,setSelectedBatch, setTransferModal ,batchDocEntry,batchItem}) => {
    // const { GetToWarehouse, loading, error } = useSelector((state) => state.InvTransfer || {});
    const { DisassembleBatch,DisassambleITPost,error,loading } = useSelector((state) => state.Disassemble);
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const InputFields = ['batch_Number'];
    // const [openManual, setOpenManual] = useState(false);
    const [tableRows, setTableRows] = useState([]);
    const [postTrigger, setPostTrigger] = useState(false);
    const [QrTrigger, setQrTrigger] = useState(false);
    const [scanBatch,setScanBatch]=useState([]);
    const [rowIndex, setRowIndex] = useState("");
    const [editMode, setEditMode] = useState(false);
    const initialValues = [{
        quantity: 0,
        item_Code: "",
        Batch_Number: "",
        from_Whs: "",
        toWhs: "",
        remarks: "",
        absEntry:""
    }]
    const [values, setValues] = useState(initialValues);
    
    useEffect(() => {   
        if (postTrigger && DisassambleITPost === 'Success') { 
            toast.success(t("Transferred successfully")); 
            setTransferModal(false);
            setTableRows([]); 
            setValues(initialValues);
            dispatch(GetDisassembleInput());
            setPostTrigger(false);            
          }
          if (postTrigger && error.DisassambleITPostError) {  
            toast.error(`${error.DisassambleITPostError.errorMessage}`);
            setPostTrigger(false);
            dispatch(resetError());
          }
      }, [DisassambleITPost, error,postTrigger]);
    
    useEffect(() => {
        if ((!DisassembleBatch || DisassembleBatch.length === 0) && batchItem) {
            dispatch(GetDisassembleBatch({ ItemCode: batchItem }));
        }
    }, [DisassembleBatch, dispatch]);

    // useEffect(() => {
    //     if (QrTrigger) {
    //        const itemBatch=values;           
    //         const filtered = DisassembleBatch.filter(item =>
    //             item.batch_Number.toLowerCase().includes(itemBatch.Batch_Number.toLowerCase())
    //         );
            
    //         if (filtered.length === 0) {
    //             toast.error(t("Batch Number not found!"));
    //         } else {
              
    //             handleDropdownClick(filtered[0]);
    //             setOpenManual(true);
    //             setQrTrigger(false);
    //         }
    //     }
    // }, [QrTrigger]);

    const tableHeader = useMemo(() => {
        return DisassembleBatch?.length > 0
            ? Object.keys(DisassembleBatch[0]).filter(header => header !== 'docEntry' && header !== 'u_STATUS' && header !== 'absEntry')
            : [];
    }, [DisassembleBatch]);
    

    const handleTransferClose = () => {
        setTransferModal(false);
        setTableRows('');
        setValues('');
        
    };
    const handleDropdownClick = (item, fieldname) => {
        setValues(item);
        setTableRows([item]);         
    }

    const handleQrScan = (scanResult) => {
        // let data;
        // try {
        //     data = parseFormattedQRText(scanResult);
        // } catch (err) {
        //     console.error("Invalid QR scan result:", err);
        //     return;
        // }
        // const batchNumber = data?.BatchNumber?.trim();
        const batchNumber = scanResult["batchnumber"].trim();
        if (!batchNumber) {
            toast.error(t('Batch Number not found!'));
            return;
        }
        const matchingBatchNumbers = DisassembleBatch &&DisassembleBatch?.filter(
            item => item.batch_Number?.toLowerCase() === batchNumber.toLowerCase()
          );
          if (!matchingBatchNumbers) {
            toast.error(t('No matching records found.'));
        }else{
            handleDropdownClick(matchingBatchNumbers[0]);
        setOpenManual(true);
        }   
      };
     
  
    //   const onDelete = (action, rowIndex) => {
    //     const updatedTableBody = tableRows.filter((_, index) => index !== rowIndex);
    //     setTableRows(updatedTableBody);
    // }
    const handleTransferPost = () => {
        // Add the remarks to each row in the tableBody
        // dispatch(resetError());   
        if(tableRows.length === 0){
             toast.error(t('Select a batch to transfer.'));
             return
        }     
        const datapost = tableRows.map((row) => ({
            Item_Code: row.item_Code,   
            batch_Number: row.batch_Number, 
            quantity: row.quantity,
            u_STATUS: row.u_STATUS,
            absEntry: row.absEntry,
            from_Whs: "RM",          
            toWhs: "SIP",             
            remarks: "string",         
            refDocEntry: batchDocEntry           
          }));
          setPostTrigger(true);
        dispatch(postDisassembleIT(datapost));
        // Dispatch the updated table data to the postITR action
        // dispatch(postITR(datapost));
      };
    return (
        <Dialog open={transferModal} >
            <DialogTitle className='Modal-heading'>{t('Inventory Transfer')}</DialogTitle>
            <DialogContent className="custom-dialog-content">
            {openManual ? (
                <div className="transfer-data">
                    <CommonSearch
                        inputFields={InputFields}
                        data={DisassembleBatch}
                        values={values}
                        setValues={setValues}
                        handleDropdownClick={handleDropdownClick} />

                    {tableHeader?.length > 0 &&
                        <DynamicTable
                            header={tableHeader}
                            tablebody={tableRows}
                            pageName={'Disassemble'}
                            // onEdit={onEdit}
                            // onDelete={onDelete}
                            // onPrint={onPrint}
                        />}
                </div>
                         ) : (
                            <div>
                                <QrContainer openManual={openManual} elementId="Dissasmble_Transfer" onScan={handleQrScan} />

                            </div>
                        )}
            </DialogContent>
            <DialogActions className="custom-dialog-actions">
                <Button onClick={() => setOpenManual(!openManual)}>
                    {openManual ? "Scanner" : "Manual"}
                </Button>
                <Button onClick={handleTransferClose} className='Modal-cancel'>Cancel</Button>
                <Button onClick={handleTransferPost} className='Modal-submit'>Transfer</Button>
            </DialogActions>
        </Dialog>
    );
};

export default DisassembleTransfer;